<script setup lang="ts">
import Breadcumb from "~/components/Breadcumb.vue";
const router = useRouter();

const { data: aboutMeData } = await useFetch<AboutMeData>("/api/about-me");
const { data: socials } = await useFetch("/api/socials");



useHead({
  title: "Contact",
});
// const { data } = await useFetch<AboutMeData>("/api/contact-me");
</script>
<template>
  <div class="content" style="">
    <Breadcumb :title="'Contact'" :subtitle="'Get in touch with me.'" :items="[{ text: 'Home', href: '/' }]" :to="{ text: 'Contact', href: '/contact' }" />
    <!-- Contact From Start -->
    <div class="xboot-standard-row contact-section contact-style-2 gray-bg">
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-md-push-4">
            <div class="section-title text-left">
              <h2 class="area-title">Contact</h2>
              <p class="area-subtitle">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Porro labore ab voluptatem. Ut obcaecati quasi ullam, eaque deserunt, itaque soluta!</p>
            </div>
            <ContactForm />
          </div>
          <div class="col-md-4 col-md-pull-8">
            <div class="contact-widget-wrap">
              <div class="contact-sub-heading">
                <h5 class="contatct-title">Get in Touch</h5>
                <!-- <p class="contact-subtitle">Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.</p> -->
              </div>
              <div class="widget-content">
                <div class="single-address-box" v-if="aboutMeData?.address">
                  <div class="address-icon">
                    <i class="ti-location-pin"></i>
                  </div>
                  <div class="address-text">
                    <p>
                      {{ aboutMeData?.address }}
                    </p>
                  </div>
                </div>
                <div class="single-address-box" v-if="aboutMeData?.email">
                  <div class="address-icon">
                    <i class="fa fa-envelope-o"></i>
                  </div>
                  <div class="address-text">
                    <a href="mailto:info@yourdomain.com">{{ aboutMeData?.email }}</a>
                  </div>
                </div>
                <div class="single-address-box" v-if="aboutMeData?.phone">
                  <div class="address-icon">
                    <i class="ti-mobile"></i>
                  </div>
                  <div class="address-text">
                    <p>{{ aboutMeData?.phone }}</p>
                  </div>
                </div>
                <div class="single-address-box" v-if="socials?.facebook">
                  <div class="address-icon">
                    <i class="fa fa-facebook"></i>
                  </div>
                  <div class="address-text">
                    <a :href="socials.facebook">Facebook</a>
                  </div>
                </div>
                <div class="single-address-box" v-if="socials?.x">
                  <div class="address-icon">
                    <i class="fa fa-twitter"></i>
                  </div>
                  <div class="address-text">
                    <a :href="socials.x">Twitter</a>
                  </div>
                </div>
                <div class="single-address-box" v-if="socials?.google">
                  <div class="address-icon">
                    <i class="fa fa-google-plus"></i>
                  </div>
                  <div class="address-text">
                    <a :href="socials.google">Google Plus</a>
                  </div>
                </div>
                <div class="single-address-box" v-if="socials?.instagram">
                  <div class="address-icon">
                    <i class="fa fa-instagram"></i>
                  </div>
                  <div class="address-text">
                    <a :href="socials.instagram">Instagram</a>
                  </div>
                </div>
                <div class="single-address-box" v-if="socials?.soundcloud">
                  <div class="address-icon">
                    <i class="fa fa-soundcloud"></i>
                  </div>
                  <div class="address-text">
                    <a :href="socials.soundcloud">SoundCloud</a>
                  </div>
                </div>
                <div class="single-address-box" v-if="socials?.linkedin">
                  <div class="address-icon">
                    <i class="fa fa-linkedin"></i>
                  </div>
                  <div class="address-text">
                    <a :href="socials.linkedin">LinkedIn</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Contact From End -->
    <!-- xboot map start -->
    <!-- <div class="map-row">
      <div id="map"></div>
    </div> -->
    <!-- xboot map end -->
  </div>
</template>
<style scoped>
.response-alert {
  width: 100%;
  position: absolute;
  top: 65px;
  /* left: 50%; */
  /* bottom: 0; */
  /* transform: translate(-50%, 0); */
  z-index: 9999;
}
i{
  color: var(--title-color);
}

.area-title {
  color: var(--primary-color);
}
.area-subtitle, .contatct-title, .address-text a, .address-text p {
  color: var(--subtitle-color);
}

.contact-subtitle {
  color: var(--paragraph-color);
}
</style>
